import constants from "../../constants";
import FavoriteButton from "../FavoriteButton";

interface StockPhotoCardProps {
  image: any;
  isFavorite?: boolean;
  toggleFavoriteCallback?: () => void;
}

export default function StockPhotoCard({ image, isFavorite = false, toggleFavoriteCallback }: StockPhotoCardProps) {

  let pixabayId = image.id || image.pixabayId;
  let hoverDiv = (<div class="author-info"><a href={image.pageURL} target="_blank">{image.user} | Pixabay</a></div>)

  return (
    <div class="component template frame" data-component="frame">
      <div data-type="frame" class="frame" data-component="frame" data-path-original={image.largeImageURL}
        data-pixabay-info={`{"id":${pixabayId}, "user":"${image.user}", "pageURL":"${image.pageURL}", "previewURL":"${image.previewURL}", "tags":"${image.tags ? image.tags : ''}"}`}>
        <div className="img" data-original-bg-img={image.largeImageURL} style={`width: 100%; height: 100%;`}>
          <picture>
            <source srcSet={image.previewURL} type="image/jpg" />
            <img style="width: 100%; height: 100%;" className="img" src={image.previewURL} alt={image.tags ? image.tags : ''} />
          </picture>
          <FavoriteButton assetId={pixabayId} type="stock-photo" isFavorite={isFavorite} callback={toggleFavoriteCallback} />
        </div>
        {hoverDiv}
      </div>
    </div>
  )

}
